export const SmsFemaleConnectionOptions = [
  { key: '1', value: '81200000025', label: 25 },
  { key: '2', value: '81200000032', label: 32 },
  { key: '3', value: '81200000038', label: 38 },
  { key: '4', value: '81200000051', label: 51 },
  { key: '5', value: '81200000063', label: 63 },
  { key: '6', value: '81200000076', label: 76 },
  { key: '7', value: '81200000100', label: 104 },
];

export const SmsFemaleEPDMConnectionOptions = [
  { key: '1', value: '81300000025', label: 25 },
  { key: '3', value: '81300000038', label: 38 },
  { key: '4', value: '81300000051', label: 51 },
  { key: '5', value: '81300000063', label: 63 },
  { key: '6', value: '81300000076', label: 76 },
];

export const SmsFemaleConnectedOptions = [
  { key: '1', value: '81400000025', label: 25 },
  { key: '3', value: '81400000038', label: 38 },
  { key: '4', value: '81400000051', label: 51 },
  { key: '5', value: '81400000063', label: 63 },
  { key: '6', value: '81400000076', label: 76 },
];

export const SmsMaleConnectionOptions = [
  { key: '1', value: '81500000025', label: 25 },
  { key: '3', value: '81500000038', label: 38 },
  { key: '4', value: '81500000051', label: 51 },
  { key: '5', value: '81500000063', label: 63 },
  { key: '6', value: '81500000076', label: 76 },
  { key: '7', value: '81500000100', label: 104 },
];

export const DinFemaleConnectionOptions = [
  { key: '1', value: '82200000025', label: 25 },
  { key: '2', value: '82200000032', label: 32 },
  { key: '3', value: '82200000038', label: 40 },
  { key: '4', value: '82200000051', label: 50 },
  { key: '5', value: '82200000063', label: 65 },
  { key: '6', value: '82200000076', label: 80 },
  { key: '7', value: '82200000100', label: 100 },
];

export const DinFemaleEPDMConnectionOptions = [
  { key: '1', value: '82300000025', label: 25 },
  { key: '2', value: '82300000032', label: 32 },
  { key: '3', value: '82300000038', label: 40 },
  { key: '4', value: '82300000051', label: 50 },
  { key: '5', value: '82300000063', label: 65 },
  { key: '6', value: '82300000076', label: 80 },
];

export const DinFemaleConnectedOptions = [
  { key: '1', value: '82400000025', label: 25 },
  { key: '2', value: '82400000032', label: 32 },
  { key: '3', value: '82400000038', label: 40 },
  { key: '4', value: '82400000051', label: 50 },
  { key: '5', value: '82400000063', label: 65 },
  { key: '6', value: '82400000076', label: 80 },
];

export const DinMaleConnectionOptions = [
  { key: '1', value: '82500000025', label: 25 },
  { key: '2', value: '82500000032', label: 32 },
  { key: '3', value: '82500000038', label: 40 },
  { key: '4', value: '82500000051', label: 50 },
  { key: '5', value: '82500000063', label: 65 },
  { key: '6', value: '82500000076', label: 80 },
  { key: '7', value: '82500000100', label: 100 },
];

export const ClampConnectionOptions = [
  { key: '1', value: '85000000025', label: 25 },
  { key: '2', value: '85000000038', label: 38 },
  { key: '3', value: '85000000050', label: 51 },
  { key: '4', value: '85000000065', label: 63 },
  { key: '5', value: '85000000080', label: 76 },
  { key: '6', value: '81200000100', label: 104 },
];

export const CamlockConnectionOptions = [
  { key: '1', value: 25, label: 25 },
  { key: '2', value: 32, label: 32 },
  { key: '3', value: 40, label: 40 },
  { key: '4', value: 50, label: 50 },
  { key: '5', value: 65, label: 65 },
  { key: '6', value: 80, label: 80 },
  { key: '7', value: 100, label: 100 },
  { key: '8', value: 125, label: 125 },
  { key: '9', value: 150, label: 150 },
];

export const GuilleminConnectionOptions = [
  { key: '1', value: '84000000025', label: 25 },
  { key: '2', value: '84000000032', label: 32 },
  { key: '3', value: '84000000040', label: 40 },
  { key: '4', value: '84000000050', label: 50 },
  { key: '5', value: '84000000065', label: 65 },
  { key: '6', value: '84000000080', label: 80 },
  { key: '7', value: '84000000100', label: 100 },
  { key: '8', value: '84000000150', label: 150 },
];

export const typeOptions = [
  {
    key: '1', value: 'sms femelle écrou inox', label: 'sms femelle écrou inox', letter: 'A', doptions: SmsFemaleConnectionOptions
  },
  {
    key: '2', value: 'sms femelle écrou revêtu EPDM', label: 'sms femelle écrou revêtu EPDM', letter: 'B', doptions: SmsFemaleEPDMConnectionOptions
  },
  {
    key: '3', value: 'sms femelle écrou connecté', label: 'sms femelle écrou connecté', letter: 'C', doptions: SmsFemaleConnectedOptions
  },
  {
    key: '4', value: 'sms mâle', label: 'sms mâle', letter: 'D', doptions: SmsMaleConnectionOptions
  },
  {
    key: '5', value: 'DIN femelle écrou inox', label: 'DIN femelle écrou inox', letter: 'E', doptions: DinFemaleConnectionOptions
  },
  {
    key: '6', value: 'DIN femelle écrou revêtu EPDM', label: 'DIN femelle écrou revêtu EPDM', letter: 'F', doptions: DinFemaleEPDMConnectionOptions
  },
  {
    key: '7', value: 'DIN femelle écrou connecté', label: 'DIN femelle écrou connecté', letter: 'G', doptions: DinFemaleConnectedOptions
  },
  {
    key: '8', value: 'DIN mâle', label: 'DIN mâle', letter: 'H', doptions: DinMaleConnectionOptions
  },
  {
    key: '9', value: 'Macon femelle écrou inox  queue 25', label: 'Macon femelle écrou inox  queue 25', letter: 'I', doptions: [{ key: '1', value: '83200040025', label: 40 }]
  },
  {
    key: '10', value: 'Macon femelle écrou inox  queue 32', label: 'Macon femelle écrou inox  queue 32', letter: 'I', doptions: [{ key: '1', value: '83200040032', label: 40 }]
  },
  {
    key: '11', value: 'Macon femelle écrou inox  queue 38', label: 'Macon femelle écrou inox  queue 38', letter: 'I', doptions: [{ key: '1', value: '83200040038', label: 40 }]
  },
  {
    key: '12', value: 'Macon femelle écrou inox  queue 51', label: 'Macon femelle écrou inox  queue 51', letter: 'I', doptions: [{ key: '1', value: '83200050051', label: 50 }]
  },
  {
    key: '13', value: 'Macon femelle écrou inox  queue 63', label: 'Macon femelle écrou inox  queue 63', letter: 'I', doptions: [{ key: '1', value: '83200070063', label: 70 }]
  },
  {
    key: '14', value: 'Macon femelle écrou inox  queue 70', label: 'Macon femelle écrou inox  queue 70', letter: 'I', doptions: [{ key: '1', value: '83300070070', label: 70 }]
  },
  {
    key: '15', value: 'Macon femelle écrou inox  queue 76', label: 'Macon femelle écrou inox  queue 76', letter: 'I', doptions: [{ key: '1', value: '83200080076', label: 80 }]
  },
  {
    key: '16', value: 'Macon femelle écrou revêtu EPDM queue 25', label: 'Macon femelle écrou revêtu EPDM queue 25', letter: 'J', doptions: [{ key: '1', value: '83300040025', label: 40 }]
  },
  {
    key: '17', value: 'Macon femelle écrou revêtu EPDM queue 32', label: 'Macon femelle écrou revêtu EPDM queue 32', letter: 'J', doptions: [{ key: '1', value: '83300040032', label: 40 }]
  },
  {
    key: '18', value: 'Macon femelle écrou revêtu EPDM queue 38', label: 'Macon femelle écrou revêtu EPDM queue 38', letter: 'J', doptions: [{ key: '1', value: '83300040038', label: 40 }]
  },
  {
    key: '19', value: 'Macon femelle écrou revêtu EPDM queue 51', label: 'Macon femelle écrou revêtu EPDM queue 51', letter: 'J', doptions: [{ key: '1', value: '83300050051', label: 50 }]
  },
  {
    key: '20', value: 'Macon femelle écrou revêtu EPDM queue 63', label: 'Macon femelle écrou revêtu EPDM queue 63', letter: 'J', doptions: [{ key: '1', value: '83300070063', label: 70 }]
  },
  {
    key: '21', value: 'Macon femelle écrou revêtu EPDM queue 70', label: 'Macon femelle écrou revêtu EPDM queue 70', letter: 'J', doptions: [{ key: '1', value: '83300070070', label: 70 }]
  },
  {
    key: '22', value: 'Macon femelle écrou connecté queue 25', label: 'Macon femelle écrou connecté queue 25', letter: 'K', doptions: [{ key: '1', value: '83400040025', label: 40 }]
  },
  {
    key: '23', value: 'Macon femelle écrou connecté queue 32', label: 'Macon femelle écrou connecté queue 32', letter: 'K', doptions: [{ key: '1', value: '83400040032', label: 40 }]
  },
  {
    key: '24', value: 'Macon femelle écrou connecté queue 38', label: 'Macon femelle écrou connecté queue 38', letter: 'K', doptions: [{ key: '1', value: '83400040038', label: 40 }]
  },
  {
    key: '25', value: 'Macon femelle écrou connecté queue 51', label: 'Macon femelle écrou connecté queue 51', letter: 'K', doptions: [{ key: '1', value: '83400050051', label: 50 }]
  },
  {
    key: '26', value: 'Macon femelle écrou connecté queue 63', label: 'Macon femelle écrou connecté queue 63', letter: 'K', doptions: [{ key: '1', value: '83400070063', label: 70 }]
  },
  {
    key: '27', value: 'Macon femelle écrou connecté queue 70', label: 'Macon femelle écrou connecté queue 70', letter: 'K', doptions: [{ key: '1', value: '83400070070', label: 70 }]
  },
  {
    key: '28', value: 'Macon mâle queue 32', label: 'Macon mâle queue 32', letter: 'L', doptions: [{ key: '1', value: '83500040032', label: 40 }]
  },
  {
    key: '29', value: 'Macon mâle queue 38', label: 'Macon mâle queue 38', letter: 'L', doptions: [{ key: '1', value: '83500040038', label: 40 }]
  },
  {
    key: '30', value: 'Macon mâle queue 51', label: 'Macon mâle queue 51', letter: 'L', doptions: [{ key: '1', value: '83500050051', label: 50 }]
  },
  {
    key: '31', value: 'Macon mâle queue 70', label: 'Macon mâle queue 70', letter: 'L', doptions: [{ key: '1', value: '83500070070', label: 70 }]
  },
  {
    key: '32', value: 'Clamp norme sms inox', label: 'Clamp norme sms inox', letter: 'M', doptions: ClampConnectionOptions
  },
  {
    key: '33', value: 'Guillemin inox standard', label: 'Guillemin inox standard', letter: 'N', doptions: GuilleminConnectionOptions
  },
];

export const flexibleDiameterOptions = [
  { key: '1', value: 19, label: 19 },
  { key: '2', value: 25, label: 25 },
  { key: '3', value: 32, label: 32 },
  { key: '4', value: 38, label: 38 },
  { key: '5', value: 50, label: 50 },
  { key: '6', value: 51, label: 51 },
  { key: '7', value: 63, label: 63 },
  { key: '8', value: 70, label: 70 },
  { key: '9', value: 75, label: 75 },
  { key: '10', value: 76, label: 76 },
  { key: '11', value: 100, label: 100 },
  { key: '12', value: 102, label: 102 },
  { key: '13', value: 125, label: 125 },
  { key: '15', value: 150, label: 150 },
];

export const numberCyclesOptions = [
  { key: '1', value: 1, label: '1' },
  { key: '2', value: 2, label: '2' },
  { key: '3', value: 3, label: '3' },
  { key: '5', value: 4, label: '4' },
  { key: '3', value: 5, label: '5+' },
];

export const rightAngledOptions = [
  { key: '1', value: 0, label: 'Non' },
  { key: '2', value: 30, label: '30°' },
  { key: '3', value: 45, label: '45°' },
  { key: '5', value: 90, label: '90°' },
];

export const washersCompatiblePerConnection = [
  {
    connections: ['5028758', '5603606', '0060268', '0125182', '5500495', '5513995'],
    yellow: '79102517589',
    red: '79202518251'
  },
  {
    connections: ['5028814', '5513359', '5009538', '0061704', '5009535', '5514149'],
    yellow: '79103200421',
    red: null
  },
  {
    connections: ['5028331', '5603526', '0072269', '0061706', '0123414', '5010974', '5513997', '5027614', '5601686'],
    yellow: '79103817594',
    red: '79203818252'
  },
  {
    connections: ['5603527', '0128343', '0060269', '5027201', '5600321', '5028332', '0128280', '5013647', '5028661', '5513999', '5513953'],
    yellow: '79105117602',
    red: '79205118253'
  },
  {
    connections: ['5028386', '5603528', '0128406', '5513104', '0128223', '5013648', '5011014', '5514001', '5513954', '5007907', '5027179'],
    yellow: '79106317661',
    red: '79206318254'
  },
  {
    connections: ['5028485', '0127410', '5500513', '5600323'],
    yellow: '79207000471',
    red: null
  },
  {
    connections: ['5603529', '0070095', '0060271', '5513061', '5600324', '5010084', '0128282', '5600927', '5010396', '5514003', '5513955'],
    yellow: '79107617662',
    red: '79207618255'
  },
  {
    connections: ['5603530', '0072081', '0061713', '0127738', '5514005', '5513067', '5600385', '5500521', '5513957'],
    yellow: '79110417663',
    red: '79210418256'
  },
  {
    connections: ['5603531', '0070333', '0097482', '5501068', '5513959', '5028739'],
    yellow: '79112500190',
    red: '79212500513'
  },
  {
    connections: ['5603532', '5011102', '0095257', '5513960', '5012291'],
    yellow: '79115000191',
    red: '79215000514'
  },
];
